export default __webpack_public_path__ + "static/the-farmstand-hover-2fb29b9d923d0995151d72531bff806c.png";